import { CLASSES as C, COLORS } from '../../globals/constants';
import './style.scss';

export default class Gradient {
  constructor(parent, controlPercent, colorStart, colorStop, width, height) {
    this.parent = parent;
    this.controlPercent = controlPercent
    this.colorStart = colorStart
    this.colorStop = colorStop
    this.width = width
    this.height = height
    this.el = this.parent
      .append('div')
      .attr('class', C.GRADIENT)
      .style("background", `
      linear-gradient(
        to right,
        ${this.colorStart} 0%,
        white ${this.controlPercent}%,
        ${this.colorStop} 100%)
    `)
      .style("width", `${this.width}px`)
      .style("height", `${this.height}px`)


  }
}
